import * as Actions from 'store/actions/app/product_files.actions'

const initialState = {
  saving_product_description: false,
  saved_product_description: false,
}

const productFilesReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.SAVE_PRODUCT_DESCRIPTION: {
      return {
        ...state,
        saving_product_description: action.payload.saving_product_description ?? false,
        saved_product_description: action.payload.saving_product_description ?? false
      }
    }
    default: {
      return state
    }
  }
}
export default productFilesReducer
